module.exports = __webpack_public_path__ + "static/media/tachometer-slow.3bb71568.svg";